exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".control--3xuhF {\n  max-width: 260px;\n  display: inline-block;\n  padding: 0 5px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n\n.modal--2-X3P {\n  max-width: 600px;\n}\n\n.modal-content--2VzIz {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  width: 100%;\n}\n\n.inputs--1KbSh {\n  max-width: 380px;\n  margin: 0 auto;\n  margin-bottom: 20px;\n}\n\n.summary--nMZHn {\n  text-align: center;\n  font-weight: 400;\n  margin-bottom: 20px;\n}\n\n.submit--2b1Kb {\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.submit--2b1Kb .button--3Ro4I {\n  margin: 10px;\n}\n", ""]);

// exports
exports.locals = {
	"control": "control--3xuhF",
	"modal": "modal--2-X3P",
	"modal-content": "modal-content--2VzIz",
	"inputs": "inputs--1KbSh",
	"summary": "summary--nMZHn",
	"submit": "submit--2b1Kb",
	"button": "button--3Ro4I"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":false,"sourceMap":false,"localIdentName":"[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false,"plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js?{"data":"$env: production;","sourceMap":false,"outputStyle":"expanded","precision":10,"includePaths":["/app/node_modules","/app/src"]}!./src/components/list-items/ProcessingUser/ProcessingUserAccesses/AddProcessingUserAccess/AddProcessingUserAccess.m.scss
// module id = 1570
// module chunks = 0